// @ts-check

const options = {
  submit: {
    // Replace any <input type="submit" /> elements with a <button type="submit" />
    // This allows us to add our standard arrow decorator to the buttons.
    selector: "input[type='submit']",
    processor: 'inputToButton'
  },
  textarea: {
    // Allow the textarea at the bottom of the pages to autogrow depending on the content.
    selector: "textarea.hs-input",
    processor: 'autoGrow',
  }
}

const getElements = (selector: string) => document.querySelectorAll(selector)

const processors = {
  autoGrow: (element: HTMLElement) => {
    element.addEventListener('input', (evt: Event) => {
      const target = evt.target as HTMLFormElement;
      const parent = target.parentNode as HTMLElement;
      if (target && parent) {
        parent.dataset.value = target?.value;
      }
    })
  },
  inputToButton: (input: HTMLFormElement) => {
    const inputClasses = input.classList;
    const button = document.createElement("button");
    button.type = "submit";
    inputClasses.forEach(className => {
      button.classList.add(className);
    })
    button.classList.add('transformed');
    button.innerHTML = `${input.value} <span class="material-icons">arrow_forward</span>`;
    input.replaceWith(button);
  }
}

const processForms = (items:NodeListOf<Element>, processor:string) => {
  if (items.length > 0) {
    items.forEach((item) => {
      processors[`${processor}`](item as HTMLFormElement);
    });
  }
}

const decorateForms = () => {
  Object.entries(options).map(([key, value]) => {
    const inputs:NodeListOf<Element> = getElements(value.selector);
    processForms(inputs, value.processor)
  })
}

export {
  decorateForms,
}
